(function () {
	const hero = () => {
		const isRTL = getComputedStyle(document.body).direction === "rtl";
		//document.addEventListener("DOMContentLoaded", () => {
		const sections = document.querySelectorAll(
			".hero-section:not(.hero_initialized), .hero-brazee-section:not(.hero_initialized)"
		);

		if (sections.length > 0) {
			sections.forEach((section) => {
				const mediaWrapper = section.querySelector(".hero_image-wrapper");
				const content = section.querySelector(".hero_content-wrapper");
				const line = section.querySelector(".hero_line");
				// For hero-brazee, ticker might be outside the section
				let ticker = section.querySelector(".hero_ticker-wrapper");
				let tickerBlock = section.querySelector(".hero_ticker-block");
				if (!ticker && section.classList.contains("hero-brazee-section")) {
					// Find ticker after the section
					const sectionId = section.id;
					const nextSibling = section.nextElementSibling;
					if (nextSibling && nextSibling.classList.contains("hero_ticker-box")) {
						ticker = nextSibling.querySelector(".hero_ticker-wrapper");
						tickerBlock = nextSibling.querySelector(".hero_ticker-block");
					}
				}
				const tickerText = ticker
					? ticker.querySelector(".hero_ticker-text")
					: null;

				const isInViewport = (el) => {
					const rect = el.getBoundingClientRect();
					return rect.top < window.innerHeight && rect.bottom >= 0;
				};

				const calculateTransition = (word) => {
					const wordLength = word.textContent.trim().length; // The length of the word
					const baseDuration = 1500;
					const totalDuration = baseDuration + wordLength * 50; // We increase the duration depending on the length
					const cubicBezier = "cubic-bezier(.23, 1, .32, 1)";

					return {
						duration: `${totalDuration}ms`,
						easing: cubicBezier,
					};
				};

				// Function to reveal words with intervals
				let wordsRevealed = false;
				const revealWords = (targetSection) => {
					if (wordsRevealed) {
						return; // Prevent multiple calls
					}
					// For hero-brazee, ticker might be outside the section
					let tickerBox = targetSection.querySelector(".hero_ticker-box");
					if (!tickerBox && targetSection.classList.contains("hero-brazee-section")) {
						const nextSibling = targetSection.nextElementSibling;
						if (nextSibling && nextSibling.classList.contains("hero_ticker-box")) {
							tickerBox = nextSibling;
						}
					}
					if (!tickerBox) {
						return;
					}
					wordsRevealed = true;
					const allTickers = tickerBox.querySelectorAll(".hero_ticker-text");
					let delayOffset = 0;

					allTickers.forEach((currentTicker, tickerIndex) => {
						const wordElements = currentTicker.querySelectorAll(".ticker-word");
						wordElements.forEach((word, wordIndex) => {
							const { duration, easing } = calculateTransition(word);

							setTimeout(() => {
								word.style.transition = `transform ${duration} ${easing}`;
								word.classList.add("visible");
							}, delayOffset + wordIndex * 100); // The interval between words
						});

						// We increase the overall offset after the animation of the current tickerText
						delayOffset += wordElements.length * 100;
					});
				};

				let hasRevealedWords = false;
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								if (entry.target.classList.contains("hero_line")) {
									setTimeout(() => {
										entry.target.classList.add("visible");
									}, 500);
								} else {
									entry.target.classList.add("visible");
								}
								// Only reveal words once per section
								if (!hasRevealedWords) {
									revealWords(section);
									hasRevealedWords = true;
								}
								observer.unobserve(entry.target);
							}
						});
					},
					{ threshold: 0.01 }
				);

				[content, line, ticker].forEach((element) => {
					if (element) {
						observer.observe(element);
					}
				});

				if (mediaWrapper) {
					const image = mediaWrapper.querySelector("img");
					const video = mediaWrapper.querySelector("video");

					let mediaLoadedCount = 0;
					let totalMedia = 0;

					if (image) {
						totalMedia = 1;
						imagesLoaded(image, function () {
							mediaLoadedCount++;
							if (mediaLoadedCount === totalMedia) {
								image.classList.add("hero_media_loaded");
							}
						});
					}

					if (video) {
						totalMedia = 1;
						if (video.readyState >= 3) {
							mediaLoadedCount++;
							video.classList.add('hero_media_loaded');
						} else {
							video.addEventListener(
								'loadeddata',
								function () {
									mediaLoadedCount++;
									video.classList.add('hero_media_loaded');
								},
								{once: true}
							);
						}
					}

					if (totalMedia > 0) {
						observer.observe(mediaWrapper);
					}
				}

				if (ticker && tickerText && tickerBlock) {
					// Check if already initialized
					if (tickerBlock.classList.contains("ticker_initialized")) {
						return;
					}
					tickerBlock.classList.add("ticker_initialized");

					const originalText = tickerText.textContent
						.trim()
						.replace(/\s+/g, " ");
					const words = originalText.split(" ");

					tickerText.innerHTML = "";
					words.forEach((word) => {
						const wordElement = document.createElement("span");
						wordElement.classList.add("ticker-word");
						wordElement.textContent = word + " ";
						tickerText.appendChild(wordElement);
					});

					//revealWords(tickerText);

					const screenWidth = 2 * window.innerWidth;
					let tickerWidth = tickerText.offsetWidth;
					let numberOfClones = Math.max(
						3,
						Math.ceil(screenWidth / tickerWidth)
					);

					for (let i = 0; i < numberOfClones; i++) {
						const tickerClone = tickerText.cloneNode(true);
						ticker.appendChild(tickerClone);
					}
				}

				section.style.opacity = "1";
				section.classList.add("hero_initialized");
			});
		}
		//});
	};

	// Wrap all outside tickers in a container
	const wrapOutsideTickers = () => {
		const outsideTickers = document.querySelectorAll(".hero_ticker-box--outside");
		if (outsideTickers.length > 0 && !document.querySelector(".hero_tickers-container")) {
			const container = document.createElement("div");
			container.classList.add("hero_tickers-container");
			
			// Find the first ticker's parent to insert the container
			const firstTicker = outsideTickers[0];
			const parent = firstTicker.parentNode;
			
			// Insert container before first ticker
			parent.insertBefore(container, firstTicker);
			
			// Move all tickers into the container
			outsideTickers.forEach((ticker) => {
				container.appendChild(ticker);
			});
		}
	};

	document.addEventListener("DOMContentLoaded", function () {
		hero();
		wrapOutsideTickers();
		document.addEventListener("shopify:section:load", function () {
			hero();
			wrapOutsideTickers();
		});
	});
})();
